import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import IntegerNumberFormat from './IntegerNumberFormat';

const useStyles = makeStyles({
  quantityInputContainer: {
    '& input': {
      textAlign: 'right',
    },
  },
});

const TonsInputField: React.FC<TextFieldProps> = props => {
  const classes = useStyles();

  return (
    <TextField
      variant="outlined"
      InputProps={{
        inputComponent: IntegerNumberFormat as any,
      }}
      className={classes.quantityInputContainer}
      {...props}
    />
  );
};

export default TonsInputField;
